import { FILTERED_PROJECT_DASHBOARD_QUERY_ID } from '../../queries/redux/constants';

export const filteredDashboardSelector = state => state.queries[FILTERED_PROJECT_DASHBOARD_QUERY_ID];
